import { BANNER_WIDGET_ITEM_LINK_TYPE } from '@amondz/constants';

import {
  CategoryBannerAttachmentType,
  CategoryBannerLinkTypeText,
} from '../../../../lib/api/category/categoryBannerType';
import { CategoryBannerLinkLabelKey } from './types';

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const MAX_SLIDE_COUNT = 10;

export const CATEGORY_BANNER_LINK_TYPE_SELECT_LIST: ReadonlyArray<{ id: number; name: string }> = [
  { id: BANNER_WIDGET_ITEM_LINK_TYPE.EVENT, name: '기획전 상세 페이지' },
  { id: BANNER_WIDGET_ITEM_LINK_TYPE.PRODUCT_DETAIL, name: '상품 상세 페이지' },
  { id: BANNER_WIDGET_ITEM_LINK_TYPE.EXTERNAL_LINK, name: '외부 웹페이지' },
];

export const CATEGORY_BANNER_LINK_TEXT_TO_NUMBER: Record<CategoryBannerLinkTypeText, number> = {
  event: BANNER_WIDGET_ITEM_LINK_TYPE.EVENT,
  product: BANNER_WIDGET_ITEM_LINK_TYPE.PRODUCT_DETAIL,
  web: BANNER_WIDGET_ITEM_LINK_TYPE.EXTERNAL_LINK,
};

// 폼 상의 linkType(number) → 서버로 보낼 linkType(text) 역방향 매핑
export const CATEGORY_BANNER_LINK_NUMBER_TO_TEXT: Record<number, CategoryBannerLinkTypeText> = {
  [BANNER_WIDGET_ITEM_LINK_TYPE.EVENT]: 'event',
  [BANNER_WIDGET_ITEM_LINK_TYPE.PRODUCT_DETAIL]: 'product',
  [BANNER_WIDGET_ITEM_LINK_TYPE.EXTERNAL_LINK]: 'web',
};

export const CATEGORY_BANNER_LINK_TYPE_LABEL: Record<CategoryBannerLinkLabelKey, string> = {
  event: '기획전',
  product: '상품',
  web: '외부 웹',
  none: '링크 없음',
};

export const LINK_ID_REQUIRED_TYPES: readonly number[] = [
  BANNER_WIDGET_ITEM_LINK_TYPE.EVENT,
  BANNER_WIDGET_ITEM_LINK_TYPE.PRODUCT_DETAIL,
];

export const LINK_URL_REQUIRED_TYPES: readonly number[] = [BANNER_WIDGET_ITEM_LINK_TYPE.EXTERNAL_LINK];

export const ATTACHMENT_TYPE = {
  MOBILE: 'mobile',
  PC: 'pc',
} as const satisfies Record<string, CategoryBannerAttachmentType>;

// 슬라이드 이미지 업로드 허용 MIME 타입 및 에러 문구
export const SLIDE_IMAGE_ALLOWED_MIME_TYPES: readonly string[] = ['image/jpeg', 'image/png'];
export const SLIDE_IMAGE_INVALID_TYPE_MESSAGE = 'jpg, jpeg, png 파일만 업로드 가능합니다.';

// 노출 기간 "무기한 해제" 시 기본 복원 종료일 offset(일)
export const SLIDE_PERIOD_DEFAULT_END_DATE_OFFSET_DAYS = 7;
